import { array, create, Describe, lazy, number, StructError, type } from 'superstruct';

import { AssetDto, AssetDtoValidator, makeAssetListFromDto } from '~modules/media-library/model/AssetFactory';
import { SearchResult } from '~modules/media-library/model/SearchResult';

export type SearchResultDto = {
  numFound: number;
  start: number;
  rows: number;
  items: AssetDto[];
};

export const SearchResultDtoValidator: Describe<SearchResultDto> = type({
  numFound: number(),
  start: number(),
  rows: number(),
  items: lazy(() => array(AssetDtoValidator)),
});

export function makeSearchResult(raw: unknown): SearchResult {
  try {
    const result = create(raw, SearchResultDtoValidator);

    return {
      numFound: result.numFound,
      start: result.start,
      rows: result.rows,
      assets: makeAssetListFromDto(result.items),
    };
  } catch (err) {
    console.error(err);
    if (err instanceof StructError) {
      console.log('STRUCT-ERROR');
      console.log({ ...err });
    }

    return {
      numFound: 0,
      start: 0,
      rows: 0,
      assets: [],
    };
  }
}
